module.exports = __webpack_public_path__ + "img/upload-icon.18b0170e.png";